import { useState } from 'react'
import { useRouter } from 'next/router'
import { Box } from '@mui/material'
import Markdown from 'markdown-to-jsx'
import { Typography, InteractiveButton } from '@evocolabs/orkaui'
import Snackbar from '@mui/material/Snackbar'
import theme from '@/src/theme'
import styles from '@/pages/scss/FAQ.module.scss'
import { postFaqFeedback } from '@/src/providers/RemotePoint'

import {
  FAQSubHeader,
  fAQComponentOverrides
} from '@/src/components/FAQ/FAQUtils'
import { getEnvVar } from '@/env'

const FAQQst = ({ data }) => {
  const router = useRouter()
  const [feedback, setFeedback] = useState(null)
  const [openSnackBar, setOpenSnackBar] = useState(false)
  const { qstId } = router.query
  const question = data.results.data.filter((d) => d.id == qstId)[0]
  const section_name = question.section
  const mdOverrides = {}
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpenSnackBar(false)
  }
  fAQComponentOverrides.forEach((item, idx) => {
    const { text, component } = item
    question.content = question.content.replace(
      new RegExp(text, 'gi'),
      `<ReplacementComp${idx}/>`
    )
    mdOverrides[`ReplacementComp${idx}`] = component
  })
  let backUrl
  const urlParams = new URLSearchParams(router.query)
  if (urlParams.get('frompage') == 'search') {
    backUrl = 'GO_BACK'
  } else {
    backUrl = `/FAQ/section/${section_name}`
  }
  return (
    <Box className={styles.FaqBody}>
      <FAQSubHeader backUrl={backUrl} title={section_name} />
      <Box px={2} className={styles.faqQstItemWrapper}>
        <Typography variant="h3" mb={2}>
          {question.question}
        </Typography>
        <Markdown options={{ overrides: mdOverrides }}>
          {question.content}
        </Markdown>
        <Typography variant="h4" mt={5} fontWeight="500">
          Was this answer helpful?
        </Typography>
        <Box mt={2} className={styles.interactiveButtonWrapper}>
          <InteractiveButton
            type="thumb_up"
            // isActive={feedback === true}
            onClick={() => {
              setFeedback(true)
              postFaqFeedback(true, question.question)
              setOpenSnackBar(true)
            }}
            sx={{ width: 32, height: 32, p: '4px 5px', ml: 1 }}
            forceStroke={theme.palette.primary[500]}
            forceFill={feedback === true ? theme.palette.primary[300] : null}
          />
          <InteractiveButton
            type="thumb_down"
            // isActive={feedback === false}
            onClick={() => {
              setFeedback(false)
              postFaqFeedback(false, question.question)
              setOpenSnackBar(true)
            }}
            sx={{ width: 32, height: 32, p: '4px 5px', ml: 1 }}
            forceStroke={theme.palette.primary[500]}
            forceFill={feedback === false ? theme.palette.primary[300] : null}
          />
        </Box>
        <Snackbar
          open={openSnackBar}
          autoHideDuration={800}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          onClose={handleClose}
          message="Thanks for your feedback"
          className={styles.snackbar}
        />
      </Box>
    </Box>
  )
}

export async function getStaticPaths() {
  const url = getEnvVar('NEXT_PUBLIC_BASEURL') + 'faq/'
  const res = await fetch(url)
  const data = await res.json()
  return {
    paths: data.results.data.map((d) => {
      return {
        params: {
          qstId: d.id.toString()
        }
      }
    }),
    fallback: false
  }
}

export async function getStaticProps() {
  const url = process.env.NEXT_PUBLIC_BASEURL + 'faq/'
  const res = await fetch(url)
  const data = await res.json()
  return { props: { data }, revalidate: 600 }
}

export default FAQQst
